module.exports = __webpack_public_path__ + "static/22_tat8-8ea20c887a208f0803a5c97314ef00e3.jpg";